import { Icon, Typography } from "@outschool/backpack";
import { faFire } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import React from "react";

export default function HighDemandBanner({
  upcomingSectionCount,
  upcomingAvailableSectionCount
}: {
  upcomingSectionCount: number;
  upcomingAvailableSectionCount: number;
}): React.ReactElement | null {
  const { t } = useTranslation(
    "client\\components\\detailPage\\availableTimes\\HighDemandBanner"
  );

  // you have no upcoming sections
  // you have upcoming sections but none are full
  if (
    upcomingSectionCount === 0 ||
    upcomingAvailableSectionCount === upcomingSectionCount
  ) {
    return null;
  }

  let highDemandString;

  // you have some upcoming sections full
  if (
    upcomingAvailableSectionCount > 0 &&
    upcomingAvailableSectionCount < upcomingSectionCount
  ) {
    const totalSectionsFilled =
      upcomingSectionCount - upcomingAvailableSectionCount;
    highDemandString = t(
      "This class is in high demand! {{totalSectionsFilled}} time has sold out.",
      {
        totalSectionsFilled,
        count: totalSectionsFilled,
        defaultValue_plural: `This class is in high demand! {{totalSectionsFilled}} times have sold out.`
      }
    );
  }

  // you have sections but they're all full
  if (upcomingAvailableSectionCount === 0) {
    highDemandString = t`This class is in high demand! All times have sold out.`;
  }

  return (
    <Typography
      variant="subtitle1"
      sx={{ color: "error.600", marginTop: "0.75em" }}
      data-test-id="HighDemandBanner"
    >
      <Icon icon={faFire} />
      <Icon icon={faFire} />
      <Icon icon={faFire} sx={{ marginRight: "0.5em" }} />
      {highDemandString}
    </Typography>
  );
}
